import { createAction, props } from "@ngrx/store";
import { ValueConfPagesDto } from "../../models/ValueConfPage";

export enum ValueConfPageTypes {
    RetrieveValueConfPagesListType = '[ValueConfPages API] ValueConfPages API Success',
    InvokeValueConfPagesApiType = '[ValueConfPages API] Invoke API'
}

export const retrieveValueConfPagesList = createAction(ValueConfPageTypes.RetrieveValueConfPagesListType, props<{valueconfpages: ValueConfPagesDto}>());
export const invokeValueConfPagesApi = createAction(ValueConfPageTypes.InvokeValueConfPagesApiType, props<{ searchtext: string, docStereoTypeId: string, currentpage: number, pagesize: number, dbname: string }>());
